import styles from "./StepIndicator.module.css";
import { CheckIcon } from "../../../icons/CheckIcon";

interface StepIndicatorProps {
  readonly steps: readonly string[];
  readonly currentStep: number;
  readonly className?: string;
}

export function StepIndicator({ steps, currentStep, className }: StepIndicatorProps) {
  const count = steps.length;
  const fillPercent = count <= 1 ? 0 : Math.min(currentStep / (count - 1), 1) * 100;
  const inset = `${100 / (2 * count)}%`;

  return (
    <nav aria-label="Progress" className={`${styles.container} ${className ?? ""}`}>
      <div className={styles.track} style={{ left: inset, right: inset }} aria-hidden="true">
        <div className={styles.trackFill} style={{ width: `${fillPercent}%` }} />
      </div>
      {steps.map((label, index) => {
        const isCompleted = index < currentStep;
        const isCurrent = index === currentStep;

        return (
          <div key={label} className={styles.step}>
            <div
              className={`${styles.circle} ${isCompleted ? styles.completed : ""} ${isCurrent ? styles.current : ""}`}
              aria-current={isCurrent ? "step" : undefined}
            >
              {isCompleted ? (
                <CheckIcon width={14} height={14} aria-hidden="true" />
              ) : (
                <span>{index + 1}</span>
              )}
            </div>
            <span className={`${styles.label} ${isCurrent ? styles.labelCurrent : ""} ${isCompleted ? styles.labelCompleted : ""}`}>
              {label}
            </span>
          </div>
        );
      })}
    </nav>
  );
}
